import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-flux-large.tsx
/**
* icon.24.logo.flux.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTIxIDE4LjgxN2gtMS42NzVMMTIuMDA3IDcuNzE0bC02LjQwMyA5LjY5NWg5LjA5bC45MyAxLjQwOEgzTDEyLjAwOCA1LjE4em0tMi42NzQgMEgxNi42OGwtNC4yNTEtNi41M2gxLjYzM3ptLTYuMTY0LTIuOTY4aC0zLjExbDEuNTU0LTIuMzM2ek0yMSAxMi4wNjNoLTMuMTk1bDEuNTk3LTIuMzkzeiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-11227
*/
const Icon24LogoFluxLarge = memo(function Icon24LogoFluxLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M21 18.817h-1.675L12.007 7.714l-6.403 9.695h9.09l.93 1.408H3L12.008 5.18zm-2.674 0H16.68l-4.251-6.53h1.633zm-6.164-2.968h-3.11l1.554-2.336zM21 12.063h-3.195l1.597-2.393z"
		})
	});
});
//#endregion
export { Icon24LogoFluxLarge };

//# sourceMappingURL=icon-24-logo-flux-large.js.map